/** Returns `true` when running in a browser environment. */
function isClient() {
  return typeof window !== "undefined";
}

export { isClient };
